const ja = {
  nav: {
    about: "AIRDOAとは",
    yokohama: "横浜ヘリクルージング",
    pricing: "料金・プラン",
    firstTime: "初めての方へ",
    faq: "FAQ",
    access: "アクセス",
    gift: "ギフトチケット",
    column: "コラム",
    company: "運営会社",
    contact: "お問い合わせ",
    viewYokohama: "横浜ヘリクルージングを見る",
  },
  common: {
    viewYokohama: "横浜ヘリクルージングを見る",
    viewPricing: "料金・プランを見る",
    buyGift: "ギフトチケットを購入",
    inquire: "予約について問い合わせる",
    viewDetails: "詳しく見る",
    viewAll: "すべて見る",
    bookNow: "予約する",
    contact: "問い合わせる",
    purchase: "購入する",
    seeMore: "もっと見る",
    popular: "人気",
    preparing: "準備中",
    available: "予約受付中",
  },
  mobile: {
    pricing: "料金を見る",
    contact: "問い合わせる",
    gift: "ギフト購入",
  },
  footer: {
    tagline: "横浜の空を、特別な思い出に。\nヘリコプター遊覧予約メディア",
    categories: {
      booking: "体験予約",
      guide: "ご利用ガイド",
      about: "AIRDOAについて",
      support: "サポート",
    },
    links: {
      yokohama: "横浜ヘリクルージング",
      pricing: "料金・プラン",
      gift: "ギフトチケット",
      firstTime: "初めての方へ",
      faq: "FAQ",
      access: "アクセス",
      baggage: "持ち込み制限",
      flow: "当日の流れ",
      bookingFlow: "ご予約の流れ",
      cancelPolicy: "キャンセルポリシー",
      company: "運営会社",
      column: "コラム",
      reviews: "お客様の声",
      news: "お知らせ",
      contact: "お問い合わせ",
      privacy: "プライバシーポリシー",
      tokushoho: "特定商取引法に基づく表記",
      sitemap: "サイトマップ",
    },
    copyright: "AIRDOA. All rights reserved.",
    privacy: "プライバシーポリシー",
    tokushoho: "特定商取引法に基づく表記",
  },
  home: {
    hero: {
      badge: "横浜ヘリクルージング予約メディア",
      title: "空から、横浜を\n特別な思い出に",
      subtitle: "AIRDOAは、横浜のヘリコプター遊覧を予約できる高級体験メディア。記念日やデートに強く、初めての方にも分かりやすくご案内します。地上では見られない絶景を、空から。",
      ctaPrimary: "横浜ヘリクルージングを見る",
      ctaSecondary: "料金・プランを見る",
    },
    about: {
      label: "ABOUT AIRDOA",
      title: "AIRDOAとは何か",
      description: "AIRDOA（エアドア）は、ヘリコプター遊覧を予約できる専門WEBメディアです。特別な日の体験を、安全かつ上質に予約できることを目指しています。記念日デート、プロポーズ、観光、ギフト。空から見る横浜は、地上では味わえない感動を届けます。",
      point1Title: "予約できる送客メディア",
      point1Desc: "WEBから簡単に予約相談。専任スタッフが最適なプランをご提案します",
      point2Title: "安全性の徹底",
      point2Desc: "国土交通省認可の運航会社のみと連携。整備記録・パイロット資格を厳重に確認しています",
      point3Title: "記念日に強い",
      point3Desc: "プロポーズ・誕生日・結婚記念日に最適。ギフト包装や演出もご相談いただけます",
    },
    yokohama: {
      label: "FEATURED AREA",
      title: "横浜ヘリクルージング",
      subtitle: "横浜の象徴的な夜景を、地上からではなく空から眺める特別な体験。みなとみらいの摩天楼、ベイブリッジ、赤レンガ倉庫を、パノラマで一望できます。",
      cta: "横浜の体験を詳しく見る",
      stat1Value: "約15分〜",
      stat1Label: "最短コース",
      stat2Value: "2名〜",
      stat2Label: "搭乗定員",
      stat3Value: "夜景",
      stat3Label: "人気時間帯",
    },
    strengths: {
      label: "WHY AIRDOA",
      title: "AIRDOAが選ばれる理由",
    },
    scenes: {
      label: "SCENES",
      title: "こんなシーンで選ばれています",
    },
    plans: {
      label: "PLANS",
      title: "横浜おすすめプラン",
      subtitle: "目的や予算に合わせて、最適なコースをお選びいただけます",
      inquire: "お問い合わせください",
      popular: "人気",
    },
    steps: {
      label: "FIRST TIME",
      title: "初めての方へ",
      subtitle: "初めてのヘリコプター遊覧でも、安心してお楽しみいただけます。専任スタッフが丁寧にサポートします。",
      cta: "初めての方はこちら",
      step1Title: "WEBで簡単相談",
      step1Desc: "希望日・時間帯・人数を入力するだけ。専任スタッフが最適なプランをご提案します。",
      step2Title: "出発前の準備",
      step2Desc: "服装や持ち物、当日の流れを事前にガイド。不安な点はいつでもお問い合わせください。",
      step3Title: "特別な体験へ",
      step3Desc: "ヘリポートで受付後、パイロットと共に空へ。地上では見られない絶景が広がります。",
    },
    safety: {
      label: "SAFETY",
      title: "安全第一の運航体制",
      subtitle: "お客様の安全を最優先に、厳格な基準で運航パートナーを選定しています",
    },
    faq: {
      label: "FAQ",
      title: "よくある質問",
      cta: "その他の質問を見る",
    },
    access: {
      label: "ACCESS",
      title: "ヘリポートまでのアクセス",
      cta: "アクセス詳細を見る",
    },
    gift: {
      label: "GIFT",
      title: "大切な人へ、空の贈り物",
      cta: "ギフトチケットを購入する",
    },
    column: {
      label: "COLUMN",
      title: "コラム新着",
      subtitle: "横浜デート、ヘリ遊覧の豆知識、ギフト選びのヒントをお届け",
      cta: "コラムをすべて見る",
    },
    reviews: {
      label: "VOICE",
      title: "お客様の声",
      subtitle: "実際に体験いただいたお客様からの感想をご紹介",
      cta: "お客様の声をもっと見る",
    },
    areas: {
      label: "AREAS",
      title: "今後の展開エリア",
      subtitle: "現在、以下のエリアを準備中です。順次、予約受付を開始いたします",
    },
    finalCta: {
      title: "空から、横浜を\n特別な思い出に",
      subtitle: "地上では見られない景色を、あなたの大切な人と共に",
    },
  },
};

export default ja;
